import React from 'react';
import { Button } from 'antd';
import SVG from 'react-inlinesvg';
import {
  HomeOutlined
} from '@ant-design/icons';
import history from '../modules/history';

const NotFound = () => (
  <div key="404" className="bg-light vh-100 d-flex align-items-center flex-column justify-content-between">

    <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1">
      <h1 className="text-muted mb-0" style={{ fontSize: '9rem' }}>404</h1>
      <div className="text-dark mb-4 px-3">
        This page doesn't exist or has moved.
      </div>
      <Button type="primary" size="large"
        icon={<HomeOutlined />}
        className="ml-2"
        onClick={() => {history.push({ pathname: '/'})} }
      >
        App home
      </Button>
    </div>

    <div className="d-flex flex-shrink-1">
      <SVG width="100%" src={require('assets/media/layout/404.svg')} />
    </div>

  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./scripts/routes/NotFound.jsx